import { Link } from "react-router-dom";
import Header from "../components/header";
import ParticleBackground from "../components/particleBackground";

function Homepage() {
    return (
        <div className="relative h-screen w-full">
            <ParticleBackground
                dotColor="rgba(255, 255, 255, 1)"
                lineColor="rgba(255, 255, 255, 0.05)"
                density={50000}
                particleRadius={4}
                curvedLines={false}
                proximity={250}
                parallax={true}
                minSpeedX={0.3}
                maxSpeedX={0.6}
                minSpeedY={0.3}
                maxSpeedY={0.6}
                parallaxMultiplier={10}
            />

            <div className="absolute top-0 w-full h-full ">

                <ParticleBackground
                    dotColor="rgba(255, 255, 255, 0.5)"
                    lineColor="rgba(255, 255, 255, 0.05)"
                    density={30000}
                    particleRadius={2}
                    curvedLines={false}
                    proximity={20}
                    parallax={true}
                    minSpeedX={0.075}
                    maxSpeedX={0.15}
                    minSpeedY={0.075}
                    maxSpeedY={0.15}
                    parallaxMultiplier={20}
                />
            </div>


            <div className="absolute top-0 flex flex-col  min-h-screen w-full">


                <Header />
                

                <div class="container mt-2 md:mt-0 flex justify-center flex-col md:flex-row items-center md:h-[50vh] w-full">

                    <div class="flex flex-col md:gap-10 gap-0  ">

                        <h2 className="md:text-7xl w-full font-bold text-white ">Welcome to our Recruitment Portal</h2>
                        <p className="text-white text-balance text-xl ">
                            Looking to join our dynamic team? EXplore the Open roles right on QT global software Ltd Recruitment Portal.
                        </p>
                    </div>

                    <div className="flex justify-center md:mt-10 ">

                        <img className="banner-image" src="https://res.cloudinary.com/drimzy/image/upload/v1726767412/vecteezy_illustration-cartoon-megaphone-icon-cute-megaphone-cartoon_17745725_s5ae0f.png" alt="banner" />

                        <div className="social-links ">
                            <a href="https://www.facebook.com/qtsoftwareltd" title="" ><i class="bx bxl-facebook"></i></a>
                            <a href="https://www.instagram.com/qtglobalsoftware/" title=""><i class="bx bxl-instagram"></i></a>
                            <a href="https://www.linkedin.com/company/qtsoftwareltd/ " title=""><i class="bx bxl-linkedin"></i></a>
                            <a href="https://www.youtube.com/@qtglobal_" title=""><i class="bx bxl-youtube"></i></a>
                        </div>
                    </div>

                </div>

                <div class="container mt-[6vh] md:mt-0 flex items-center justify-center md:justify-start w-full ">



                    <Link to={"/apply"} className="button w-full md:w-auto text-center px-14 py-2.5 uppercase  hover:text-primary font-semibold tracking-wide rounded-md shadow ">


                        Start Application


                        <i className="text-center bx bx-right-arrow-alt"></i>


                    </Link>
                </div>


            </div>
        </div>
    );
}

export default Homepage;
